// ============================================================================
// N-QUEENS - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'n-queens',
  name: 'N-Queens Problem',
  category: 'Backtracking',
  complexity: {
    time: 'O(N!)',
    space: 'O(N^2)'
  },
  description: 'N-Queens places N queens on an N×N chessboard such that no two queens attack each other using backtracking.'
};
export type MetaType = typeof meta;
